import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { Disposable } from '@patsnap/tahiti-core';
import {
    OnboardingBrowserRuntime,
    type OnboardingBrowserRuntime as OnboardingBrowserRuntimeType,
} from '../onboarding-browser-runtime';
import type {
    ReportActionGuideBubblePresenter,
    ReportActionGuideBubbleShowOptions,
} from '../report-action-guide-bubble-presenter';

/** 辅助报告操作说明气泡使用的公共样式类。 */
const BUBBLE_CLASS = 'onboarding-report-action-guide-bubble';

/** 将辅助报告操作说明挂载到目标按钮内部，使其跟随目标位置和层叠上下文。 */
@injectable()
export class ReportActionGuideBubblePresenterImpl implements ReportActionGuideBubblePresenter {
    constructor(
        /** 隔离气泡宿主的 DOM 创建能力。 */
        @inject(OnboardingBrowserRuntime)
        private readonly _runtime: OnboardingBrowserRuntimeType,
    ) {}

    /** 挂载不阻断按钮交互的纯视觉说明气泡。 */
    show(options: ReportActionGuideBubbleShowOptions): Disposable {
        const bubble = this._runtime.createElement('span');
        bubble.className = BUBBLE_CLASS;
        bubble.textContent = options.description;
        bubble.setAttribute('aria-hidden', 'true');
        options.target.append(bubble);

        let isDisposed = false;
        return {
            dispose: () => {
                if (isDisposed) return;
                isDisposed = true;
                bubble.remove();
            },
        };
    }
}
